import { render, staticRenderFns } from "./CMiniMessages.vue?vue&type=template&id=3c5f38aa&scoped=true&"
import script from "./CMiniMessages.vue?vue&type=script&lang=ts&"
export * from "./CMiniMessages.vue?vue&type=script&lang=ts&"
import style0 from "./CMiniMessages.vue?vue&type=style&index=0&id=3c5f38aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5f38aa",
  null
  
)

export default component.exports